// RoleBasedRoute.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

// Role rank constants (matching backend)
const ROLE_RANKS = {
  'ADMIN': 5,
  'TECH': 5,
  'TEAM_LEADER': 4,
  'HR': 4,
  'SALES': 4,
  'QUALITY': 3,
  'SPA': 2,
  'PA': 1,
};

// Helper function to get user rank
export const getUserRank = (user) => {
  if (!user || !user.employee_profile) return 0;
  const role = user.employee_profile.role;
  return ROLE_RANKS[role] || 0;
};

// Helper function to check if user is admin
export const isAdmin = (user) => {
  return getUserRank(user) === 5 && user.employee_profile?.role === 'ADMIN';
};

// Helper function to check if user is team leader or above
export const isTeamLeaderOrAbove = (user) => {
  return getUserRank(user) >= 4;
};

// Component to protect routes based on minimum required rank
const RoleBasedRoute = ({ children, minRank, adminOnly = false, redirectTo = "/" }) => {
  const user = useSelector((state) => state.auth.user);
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  const userRank = getUserRank(user);
  
  // Check admin-only routes
  if (adminOnly && !isAdmin(user)) {
    return <Navigate to={redirectTo} replace />;
  }
  
  // Check minimum rank requirement
  if (minRank && userRank < minRank) {
    return <Navigate to={redirectTo} replace />;
  }
  
  return children;
};

export default RoleBasedRoute;